import { Entity } from "../../helpers/Entity"

export type RowCustomStatusAttributes = {
    name: string
    rank: number
    color: string
}

export interface RowCustomStatusDto {
    id: string
    type: string
    attributes: RowCustomStatusAttributes
}

export default class RowCustomStatus implements Entity {
    private dto: RowCustomStatusDto
    constructor(dto: RowCustomStatusDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "row-custom-status"
    }

    getId(): string {
        return this.dto.id
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getColor(): string {
        return this.dto.attributes.color
    }

    getAttributes(): RowCustomStatusAttributes {
        return this.dto.attributes
    }
}


// WEBPACK FOOTER //
// ./src/state/pricing/rowcustomstatus/RowCustomStatus.ts